import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

export default function BetaCodeValidation() {
  const [betaCode, setBetaCode] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Get the current user
      const { data: { user }, error: userError } = await supabase.auth.getUser();
      
      if (userError) throw userError;
      if (!user) throw new Error('No user found');

      // Validate the beta code
      const { data: validCode, error: validationError } = await supabase
        .rpc('validate_beta_code', { code: betaCode });

      if (validationError) throw validationError;

      if (validCode) {
        // Update the user's profile with the beta code
        const { error: updateError } = await supabase
          .from('profiles')
          .update({ beta_code: betaCode })
          .eq('id', user.id);

        if (updateError) throw updateError;

        toast.success('Beta code validated successfully!');
        // Force a page refresh to trigger ProtectedRoute check
        window.location.href = '/';
      } else {
        toast.error('Invalid beta code. Please try again.');
      }
    } catch (error) {
      console.error('Error validating beta code:', error);
      toast.error('An error occurred while validating the beta code.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <Input
        type="text"
        placeholder="Enter your beta code"
        value={betaCode}
        onChange={(e) => setBetaCode(e.target.value)}
        required
      />
      <Button type="submit" className="w-full" disabled={loading}>
        {loading ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Validating...
          </>
        ) : (
          'Validate Code'
        )}
      </Button>
    </form>
  );
} 